import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import { likeEvent, unlikeEvent } from '@/js/lib/api/event';
import { useEventStore } from '@/js/lib/store/event';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import LikeBalloon from '@/js/components/www.iichi.com/organisms/eventLikeBalloon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'eventLikeButton',
  props: {
    eventId: {}
  },
  setup(__props: any) {

const props = __props;
const userStore = useUserStore();
const eventStore = useEventStore();
const isLoading = ref(false);
const isLiked = computed(() => eventStore.likedEventIds.includes(props.eventId));
const like = async () => {
  eventStore.addLikedEventId(props.eventId);
  await likeEvent({ eventId: props.eventId }).catch(() => {
    eventStore.removeLikedEventId(props.eventId);
  });
};
const unlike = async () => {
  eventStore.removeLikedEventId(props.eventId);
  await unlikeEvent({ eventId: props.eventId }).catch(() => {
    eventStore.addLikedEventId(props.eventId);
  });
};
const onClick = async () => {
  if (userStore.isAuthenticated) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    await (isLiked.value ? unlike() : like());
    isLoading.value = false;
  } else {
    signinSignup({
      next: window.location.href,
      callback: async () => {
        await loading({
          asyncFunc: async () => {
            like();
            window.location.reload();
          },
          text: 'ログインしています',
        });
      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: _normalizeClass([_ctx.$style.button, isLiked.value && _ctx.$style.isLiked]),
      onClick: onClick
    }, _toDisplayString(_unref(eventStore).likedCounts[_ctx.eventId] || 0), 3),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.balloon)
    }, [
      _createVNode(LikeBalloon, { liked: isLiked.value }, null, 8, ["liked"])
    ], 2)
  ]))
}
}

})